import { ServiceTemplateType } from '@onlog-public/additional-services-types';

export const DELIVERY_SECTION_ID = 'delivery';

export const CALCULATIONS_MENU_ITEMS_LIMIT = 5;

// TODO: убрать, когда для таможенных платежей сделают восстановление и шаринг
export const CUSTOMS_PAYMENTS_GROUP_TEMPLATE: ServiceTemplateType = 'customsPaymentsGroup';
